var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6967 10.1147H4.53371C4.12461 10.1147 3.79297 10.4464 3.79297 10.8555V13.0185C3.79297 13.4276 4.12461 13.7592 4.53371 13.7592H6.6967C7.1058 13.7592 7.43744 13.4276 7.43744 13.0185V10.8555C7.43744 10.4464 7.1058 10.1147 6.6967 10.1147Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8889 19.3889H3.11112C2.70256 19.3889 2.29798 19.3084 1.92053 19.152C1.54307 18.9957 1.20012 18.7665 0.911232 18.4777C0.622338 18.1888 0.393164 17.8458 0.236816 17.4683C0.0804684 17.0909 0 16.6863 0 16.2778V7.6111C0 7.20254 0.0804684 6.79798 0.236816 6.42053C0.393164 6.04307 0.622338 5.7001 0.911232 5.41121C1.20012 5.12232 1.54307 4.89316 1.92053 4.73682C2.29798 4.58047 2.70256 4.5 3.11112 4.5H20.8889C21.714 4.5 22.5053 4.82776 23.0888 5.41121C23.6722 5.99466 24 6.78598 24 7.6111V16.2778C24 17.1029 23.6722 17.8942 23.0888 18.4777C22.5053 19.0611 21.714 19.3889 20.8889 19.3889ZM3.11112 6.57406C2.83727 6.57789 2.5757 6.68838 2.38204 6.88204C2.18838 7.0757 2.07789 7.33725 2.07406 7.6111V16.2778C2.07789 16.5516 2.18838 16.8132 2.38204 17.0068C2.5757 17.2005 2.83727 17.311 3.11112 17.3148H20.8889C21.1639 17.3148 21.4277 17.2055 21.6222 17.0111C21.8166 16.8166 21.9259 16.5528 21.9259 16.2778V7.6111C21.9259 7.33606 21.8166 7.0723 21.6222 6.87781C21.4277 6.68333 21.1639 6.57406 20.8889 6.57406H3.11112Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/Devices.0a91f643f424e8fae7967adccf915ff5.svg";
export { ForwardRef as ReactComponent };